import clsx from "clsx";
import { LayoutGroup, motion } from "framer-motion";
import { useRouter } from "next/router";
import { ReactNode } from "react";

import { easeQuartOut } from "@/utils/constants";
import { removeQueryParams } from "@/utils/router";

interface PageBodyHeaderProps {
  children?: ReactNode;
}

function PageBodyHeader({ children }: PageBodyHeaderProps) {
  return (
    <div className="relative">
      <div
        className={clsx(
          "min-h-14 lg:min-h-22 px-5 lg:px-10 flex items-center lg:rounded-t-xl",
          "overflow-x-scroll lg:overflow-x-visible w-full max-w-[1680px] mx-auto",
          "bg-dark-6/40 text-white"
        )}
      >
        <LayoutGroup id="page-body-header-layout-group">{children}</LayoutGroup>
      </div>
    </div>
  );
}

interface SectionButtonProps {
  section: string;
  active: boolean;
  label: string;
}

function SectionButton({ section, active, label }: SectionButtonProps) {
  const router = useRouter();

  return (
    <button
      onClick={() =>
        router.push(
          { pathname: router.pathname, query: { ...removeQueryParams(router.query, "page"), section } },
          undefined,
          { shallow: true }
        )
      }
      className={clsx(
        "h-8 lg:h-10 px-4 lg:px-5 flex items-center lg:text-lg lg:leading-1 font-medium relative"
      )}
    >
      {active && (
        <motion.span
          layoutId="section-bg"
          initial={false}
          transition={{ ease: easeQuartOut }}
          className={clsx(
            "absolute w-full h-full inset-0 bg-dark-7/25 rounded-full",
            "before:border before:bg-dark-stroke",
            "before:border-gradient before:rounded-full"
          )}
        />
      )}
      <span className="z-10">{label}</span>
    </button>
  );
}

PageBodyHeader.SectionButton = SectionButton;

export default PageBodyHeader;
